const LOGO_FILE_NAME = {
  BBC: 'logo-bbc',
  BLOOMBERG: 'logo-bloomberg',
  THE_SUN: 'logo-the-sun',
  BUSINESS_INSIDER: 'logo-business-insider',
  EURONEWS: 'logo-euronews',
  FORBES: 'logo-forbes',
  GOOGLE_FINANCE: 'logo-google-finance',
  MARKETWATCH: 'logo-marketwatch',
  REUTERS: 'logo-reuters',
  THE_INDEPENDENT: 'logo-the-independent',
  THE_WASHINGTON_POST: 'logo-the-washington-post',
  ALJAZEERE_TV: 'logo-aljazeere-tv',
  BUZZFEED: 'logo-buzzfeed',
  CNBC: 'logo-cnbc',
  CNN: 'logo-cnn',
  CRUNCHBASE: 'logo-crunchbase',
  STACK_EXCHANGE: 'logo-stack-exchange',
  THE_GUARDIAN: 'logo-the-guardian'
}

const LOGOS_SECTION_1 = [
  LOGO_FILE_NAME.BLOOMBERG,
  LOGO_FILE_NAME.REUTERS,
  LOGO_FILE_NAME.FORBES,
  LOGO_FILE_NAME.BBC,
  LOGO_FILE_NAME.BUSINESS_INSIDER,
  LOGO_FILE_NAME.EURONEWS,
  LOGO_FILE_NAME.GOOGLE_FINANCE,
  LOGO_FILE_NAME.MARKETWATCH,
  LOGO_FILE_NAME.THE_INDEPENDENT
]

const LOGOS_SECTION_2 = [
  LOGO_FILE_NAME.STACK_EXCHANGE,
  LOGO_FILE_NAME.THE_SUN,
  LOGO_FILE_NAME.CRUNCHBASE,
  LOGO_FILE_NAME.CNBC,
  LOGO_FILE_NAME.ALJAZEERE_TV,
  LOGO_FILE_NAME.THE_GUARDIAN,
  LOGO_FILE_NAME.CNN,
  LOGO_FILE_NAME.THE_WASHINGTON_POST,
  LOGO_FILE_NAME.BUZZFEED
]

const LOGO_ALT_BY_LOGO_FILE_NAME = {
  [LOGO_FILE_NAME.BLOOMBERG]: 'Bloomberg logo',
  [LOGO_FILE_NAME.REUTERS]: 'Reuters logo',
  [LOGO_FILE_NAME.FORBES]: 'Forbes logo',
  [LOGO_FILE_NAME.BBC]: 'BBC logo',
  [LOGO_FILE_NAME.BUSINESS_INSIDER]: 'Business Insider logo',
  [LOGO_FILE_NAME.EURONEWS]: 'Euronews logo',
  [LOGO_FILE_NAME.THE_SUN]: 'The Sun logo',
  [LOGO_FILE_NAME.GOOGLE_FINANCE]: 'Google Finance logo',
  [LOGO_FILE_NAME.MARKETWATCH]: 'Marketwatch logo',
  [LOGO_FILE_NAME.THE_INDEPENDENT]: 'The Independent logo',
  [LOGO_FILE_NAME.STACK_EXCHANGE]: 'Stack Exchange logo',
  [LOGO_FILE_NAME.CRUNCHBASE]: 'Crunchbase logo',
  [LOGO_FILE_NAME.CNBC]: 'CNBC logo',
  [LOGO_FILE_NAME.ALJAZEERE_TV]: 'Aljazeere TV logo',
  [LOGO_FILE_NAME.THE_GUARDIAN]: 'The Guardian logo',
  [LOGO_FILE_NAME.CNN]: 'CNN logo',
  [LOGO_FILE_NAME.THE_WASHINGTON_POST]: 'The Washington Post logo',
  [LOGO_FILE_NAME.BUZZFEED]: 'Buzzfeed logo'
}

function enrichLogoWithSettings(logo) {
  return {
    url: `/images/${logo}.svg`,
    alt: LOGO_ALT_BY_LOGO_FILE_NAME[logo]
  }
}

export const LOGOS_SETTINGS_SECTION_1 = LOGOS_SECTION_1.map(
  enrichLogoWithSettings
)

export const LOGOS_SETTINGS_SECTION_2 = LOGOS_SECTION_2.map(
  enrichLogoWithSettings
)

export const PAGINATION_CUSTOM_CLASS = {
  SECTION_1: 'swiper-pagination-recognized-by-1',
  SECTION_2: 'swiper-pagination-recognized-by-2'
}
